// Single source of truth for the option-tile identity system. The phone pad
// (QuizView) and the broadcast screen (PresenterView) MUST agree on which
// colour + shape an option index maps to — in stream mode the shape is the only
// link between what the player taps and what the stream shows.
//
// Colour↔shape grammar follows the convention millions of players already know
// (red ▲, blue ◆, gold ●, green ■); hues are darkened so white glyphs hold
// contrast and survive video compression. Each tile carries a border in a
// deeper shade of its own colour — depth comes from borders + hard shadows,
// never blur.
export const TILE = [
  'bg-tile-red border-tile-red-deep',
  'bg-tile-blue border-tile-blue-deep',
  'bg-tile-gold border-tile-gold-deep',
  'bg-tile-green border-tile-green-deep',
];
export const SHAPE = ['▲', '◆', '●', '■'];
// Spoken names for the glyphs — screen readers get "Answer triangle", not
// silence (the glyph characters are skipped by most readers).
export const SHAPE_NAME = ['triangle', 'diamond', 'circle', 'square'];

// Structural frame every tile shares (surfaces add their own size/layout).
export const TILE_FRAME = 'border-2 shadow-hard';

export const tileClass = (i: number) => TILE[i % TILE.length];
export const shapeOf = (i: number) => SHAPE[i % SHAPE.length];

// Reveal styling shared by both surfaces: the correct tile gets the gold ring
// (accent = meaning, never decoration), the rest fade.
export const REVEAL_CORRECT = 'ring-4 ring-accent scale-[1.03] animate-pop';
export const REVEAL_DIMMED = 'opacity-35 saturate-50';

// Leaderboard rank chips — replaces medal emoji everywhere. Gold / silver /
// bronze squares with the rank number; ranks 4+ get a quiet chip.
const RANK_CHIP = [
  'bg-accent text-ink',
  'bg-slate-300 text-ink',
  'bg-[#D08A4E] text-white',
];
export const rankChip = (i: number) =>
  `grid place-items-center w-8 h-8 rounded-lg font-display font-extrabold text-sm shrink-0 ${
    RANK_CHIP[i] ?? 'bg-slate-200/20 text-current'
  }`;
